export enum Roles {
  Doctor = 'doctor',
  NursePractitioner = 'nursePractitioner',
  PharmD = 'pharmD',
  PhysicianAssistant = 'physicianAssistant',
  QHCP = 'QHCP',
  RegisteredNurse = 'registeredNurse',
  ClientSuccessOnboarding = 'clientSuccessOnboarding',
  ClientSuccessScaling = 'clientSuccessScaling',
  ClientSuccessRepresentative = 'clientSuccessRepresentative',
  SalesRepresentative = 'salesRepresentative',
  Administrator = 'admin-panel-access',
  Support = 'support',
  Default = 'default',
  Clinical = 'clinical',
  AdminPanelAccess = 'admin-panel-access',
  AdminTools = 'adminTools',
  Biller = 'biller',
  BillingTools = 'billingTools',

  MedicalAssistant = 'medicalAssistant',
  AtRiskAlerting = 'atRiskAlerting',
  CriticalAlerting = 'criticalAlerting',
  Nutritionist = 'nutritionist',
  Onboarding = 'onboarding',
  PatientAcceptance = 'patientAcceptance',
  CallDashboard = 'callDashboard',
  Supervisor = 'supervisor',
  CallAgent = 'call-agent',
  SmsDashboard = 'smsDashboard',
  SmsDashboardUnregistered = 'smsDashboardUnregistered',
  Turk = 'turk',
  CallManager = 'callManager',
  PriorityPatientAccess = 'priorityPatientAccess',
  AccountManager = 'accountManager',
}

export enum ReadingTemplateRoles {
  RegisterNurse = 'register-nurse',
  MedicalAssistant = 'medical-assistant',
}

export enum AdminRoles {
  Default = 'default',
  Clinical = 'clinical',
}

export enum PracticeRoles {
  AdminPanelAccess = 'admin-panel-access',
  PhysicianAssistant = 'physicianAssistant',
  NursePractitioner = 'nursePractitioner',
  RegisteredNurse = 'registeredNurse',
  AdminTools = 'adminTools',
  PharmD = 'pharmD',
  Doctor = 'doctor',
  Support = 'support',
  PatientAcceptance = 'patientAcceptance',
  SmsDashboard = 'smsDashboard',
  Onboarding = 'onboarding',
  QHCP = 'QHCP',
  Biller = 'biller',
}

export enum HomeHealthRoles {
  Onboarding = 'onboarding',
  CriticalAlerting = 'criticalAlerting',
  AtRiskAlerting = 'atRiskAlerting',
  SalesRepresentative = 'salesRepresentative',
  ClientSuccessOnboarding = 'clientSuccessOnboarding',
  ClientSuccessScaling = 'clientSuccessScaling',
  AdminTools = 'adminTools',
  Turk = 'turk',
  Nutritionist = 'nutritionist',
  SmsDashboard = 'smsDashboard',
  SmsDashboardUnregistered = 'smsDashboardUnregistered',
  BillingTools = 'billingTools',
  Doctor = 'doctor',
  PhysicianAssistant = 'physicianAssistant',
  NursePractitioner = 'nursePractitioner',
  QHCP = 'QHCP',
  Biller = 'biller',
  Support = 'support',
  CcmDoctor = 'ccm-doctor',
  CcmPhysicianAssistant = 'ccm-physicianAssistant',
  CcmNursePractitioner = 'ccm-nursePractitioner',
  CcmRegisteredNurse = 'ccm-registeredNurse',
  CcmQHCP = 'ccm-QHCP',
  CcmBiller = 'ccm-biller',
  CcmSupport = 'ccm-support',
  PatientAcceptance = 'patientAcceptance',
  RegisteredNurse = 'registeredNurse',
  AdminPanelAccess = 'admin-panel-access',
}

export enum PatientRoles {
  Default = 'default',
}

export type UserRoleTypes =
  | HomeHealthRoles
  | PracticeRoles
  | AdminRoles
  | PatientRoles;
